---
de:
  ppa_pricing:
    charts:
      buy_back_cost_title: Rückkaufkosten (EUR)
      buy_back_volume_title: Rückkaufvolumen in % der Jahresproduktion
      portfolio_reference_title: Portfolio und Referenzprofil
      profile_risk: Profil-Risiko [%]
      simulated_revenue_development: Simulierte Umsatzentwicklung
    factors:
      cannibalism: Kannibalismus
      cash_flow: Cash-flow
      liquidity: Liquidität
      price: Preis
      profile: Profil
      volume: Volumen
    hedging_strategy: Absicherungsstrategie Preis und Risiken
    liquidity: Liquidität
    portfolio_attributes: Portfolio-Attribute
    pricing: Preisgestaltung
    pricing_and_risk: Produktpreise und -risiken
    risk_factors: Risikofaktoren
    risk_factors_additional: Zusätzliche Risikofaktoren
    risk_factors_mitigated: Risikofaktoren gemildert
